/**
 * Designed to replicate INI filter check of `ring:msft`.
 */
export function isMicrosoftRing(featureSettings, identity) {
    var _a;
    var msftTenantIds = (_a = featureSettings === null || featureSettings === void 0 ? void 0 : featureSettings.ring) === null || _a === void 0 ? void 0 : _a.msftTenants;
    var userTenantId = identity.tenantId;
    if (msftTenantIds &&
        msftTenantIds.split(',').some(function (msftTenantId) {
            return msftTenantId.toLowerCase() === userTenantId.toLowerCase();
        })) {
        return true;
    }
    return false;
}
//# sourceMappingURL=isMicrosoftRing.js.map